import { Paper } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { IoMdCloseCircleOutline } from "react-icons/io";
import useStyles from "./styles";

function Modal({ title, ...props }) {
  const classes = useStyles();

  return (
    // eslint-disable-next-line no-sequences
    <div className={("animate__animated animate__backInDown", classes.root)}>
      <Paper className={clsx("modal", classes.paper)}>
        <div className={classes.title}>{title}</div>
        <div
          className={classes.close}
          onClick={() => {
            props.setShowModal(false);
          }}
        >
          <IoMdCloseCircleOutline size="25px" />
        </div>
        <div className={classes.form}>{props.children}</div>
      </Paper>
    </div>
  );
}

export default Modal;
